import React from 'react';
import StatisticsCardsRepair from '../components/stats/StatisticsCardsRepair';
import Repairs from '../components/layout/repairs/Repairs';

const RepairsPage = () => {
  return (
    <>
      <StatisticsCardsRepair />
      <Repairs />
    </>
  );
};

export default RepairsPage;
